import { HStack, VStack } from 'native-base';
import Button from 'ui/components/Button';
import FormBuilderV2 from 'ui/components/FormBuilderV2';
import { FormDataIsLoading } from 'ui/components/FormBuilderV2/components/FormDataIsLoading';

import { ActivityMetrics } from './ActivityMetrics';
import { useAboutFormController } from './controller';
import { AboutFormProps } from './types';
import { MeasurementCategory } from 'ui/enums';

export const AboutForm = (props: AboutFormProps) => {
  const {
    handleContinue,
    defaultValues,
    formSchema,
    isLoading,
    activityMetricsOptions,
    control,
    clearMeasurementUnit,
    watch,
    addOneStep,
    fields,
    measurementUnit,
    handleSubmit,
    isDisabled,
    isFormLoading,
    metricsOptions,
    onChangeMeasurementUnit,
    handleBack,
  } = useAboutFormController(props);

  return (
    <VStack w="100%" space={4}>
      {isFormLoading ? (
        <FormDataIsLoading />
      ) : (
        <>
          <VStack w="full">
            <FormBuilderV2
              options={formSchema}
              onSubmit={handleContinue}
              defaultValues={defaultValues}
              isLoadingSubmit={isLoading}
            />
            <ActivityMetrics
              options={metricsOptions}
              control={control}
              watch={watch}
              clearMeasurementUnit={clearMeasurementUnit}
              onChangeMeasurementUnit={onChangeMeasurementUnit}
              addOneForm={addOneStep}
              fields={fields}
              isEditing
            />
          </VStack>
          <HStack flex={1} mt={5} space={2} justifyContent="space-between">
            <Button variant="outline" flex={0.5} onPress={handleBack}>
              Back
            </Button>
            <Button
              flex={0.5}
              onPress={handleSubmit(handleContinue)}
              isDisabled={isDisabled}
            >
              Continue
            </Button>
          </HStack>
        </>
      )}
    </VStack>
  );
};
